import * as Styled from './styled'
import TtsItemSpeakerVelocity from './Velocity'
import TtsItemSpeakerToggler from './ToggleSpeaker'
import TtsDeleteButton from './Delete'
import { memo } from 'react'

interface IProps {
  isActive: boolean
}

const TtsItemControlsButtons: React.FC<IProps> = ({ isActive }) => {
  return (
    <Styled.TtsControlsButtonsWrapper $isActive={isActive}>
      <Styled.TtsItemLeftControlsWrapper>
        <TtsItemSpeakerToggler />
        <Styled.TtsControlsDivider />
        <TtsItemSpeakerVelocity />
      </Styled.TtsItemLeftControlsWrapper>
      <TtsDeleteButton />
    </Styled.TtsControlsButtonsWrapper>
  )
}

export default memo(TtsItemControlsButtons)
